// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type EditOptionsHeaderQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type EditOptionsHeaderQuery = { __typename?: 'Query', readyPlan: { __typename?: 'ReadyPlan', id: string, name: string, development?: { __typename?: 'Development', id: string, name: string } | null | undefined } };


export const EditOptionsHeaderDocument = gql`
    query EditOptionsHeader($id: ID!) {
  readyPlan(id: $id) {
    ...Named
    development {
      ...Named
    }
  }
}
    ${NamedFragmentDoc}`;

/**
 * __useEditOptionsHeaderQuery__
 *
 * To run a query within a React component, call `useEditOptionsHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditOptionsHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditOptionsHeaderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditOptionsHeaderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EditOptionsHeaderQuery, EditOptionsHeaderQueryVariables> & ({ variables: EditOptionsHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EditOptionsHeaderQuery, EditOptionsHeaderQueryVariables>(EditOptionsHeaderDocument, options);
      }
export function useEditOptionsHeaderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EditOptionsHeaderQuery, EditOptionsHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EditOptionsHeaderQuery, EditOptionsHeaderQueryVariables>(EditOptionsHeaderDocument, options);
        }
// @ts-ignore
export function useEditOptionsHeaderSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EditOptionsHeaderQuery, EditOptionsHeaderQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EditOptionsHeaderQuery, EditOptionsHeaderQueryVariables>;
export function useEditOptionsHeaderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EditOptionsHeaderQuery, EditOptionsHeaderQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EditOptionsHeaderQuery | undefined, EditOptionsHeaderQueryVariables>;
export function useEditOptionsHeaderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EditOptionsHeaderQuery, EditOptionsHeaderQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EditOptionsHeaderQuery, EditOptionsHeaderQueryVariables>(EditOptionsHeaderDocument, options);
        }
export type EditOptionsHeaderQueryHookResult = ReturnType<typeof useEditOptionsHeaderQuery>;
export type EditOptionsHeaderLazyQueryHookResult = ReturnType<typeof useEditOptionsHeaderLazyQuery>;
export type EditOptionsHeaderSuspenseQueryHookResult = ReturnType<typeof useEditOptionsHeaderSuspenseQuery>;
export type EditOptionsHeaderQueryResult = Apollo.QueryResult<EditOptionsHeaderQuery, EditOptionsHeaderQueryVariables>;